// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1J84i","label":"Category_label__c9QgJ","content":"Category_content__314Tz","header":"Category_header__1m6aC","location":"Category_location__3Rqv7"};